import BootstrapLoader from 'common/src/components/BootstrapLoader/BootstrapLoader';
import {persistor, store} from 'common/src/redux/store';
import React, {Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';

const ContainerApp = React.lazy(() => import('container/src/ContainerApp/ContainerApp'));

const RootApp = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BootstrapLoader>
        <BrowserRouter>
          <Suspense fallback={null}>
            <ContainerApp />
          </Suspense>
        </BrowserRouter>
      </BootstrapLoader>
    </PersistGate>
  </Provider>
);

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(<RootApp />);
}
